<template>

    <div :class="{'visible':isDisplayingDownloadAlert == true}"
         class="download-alert-msg-wrapper"
         @click.stop="closeDownloadAlert()">

        <div class="download-alert-msg">
            <span class="close-btn" @click.stop="closeDownloadAlert()">Chiudi</span>
            {{ downloadAlertMsg }}

        </div>

    </div>


</template>

<script>


export default {

    data() {
        return {

            isDisplayingDownloadAlert: false,
            downloadAlertMsg:null,

        }
    },

    methods: {

        openDownloadAlert(event) {



            this.isDisplayingDownloadAlert = true;
            this.downloadAlertMsg = event.msg;
        },

        closeDownloadAlert() {

            this.isDisplayingDownloadAlert = false;

        },


    },



    components: {

    },

    created() {

      console.log("DownloadModalAlert");
      this.$eventBus.$on('download:show_alert', this.openDownloadAlert);

    }

}
</script>

<style lang="scss" scoped>

    .download-alert-msg-wrapper {

        pointer-events: none;
        opacity:0;
        position: fixed;

        background: rgba(0,0,0,.25);

        top:0;
        left:0;
        width:100%;
        height: 100vh;
        display: flex;
        align-items:center;
        justify-content: center;

    &.visible {
         pointer-events: all;
         opacity:1;
     }


    .download-alert-msg {

        background: #fff;
        position: relative;

        max-width: 600px;
        padding: 3.5rem 3rem;
        line-height: 1;

        color: black;
        font-size: 2rem;
    .close-btn{
        position: absolute;
        right: 20px;
        top: 20px;
        cursor: pointer;
        font-size: 1rem;

    }
    &:before{
         content: "";
         display: inline-block;
         position: relative;
         bottom: 2px;
         vertical-align: middle;
         width: 45px;
         height: 45px;
         background-image: url(/themes/caramba/assets/images/check.svg);
         background-size: 35px auto;
         background-position: 50%;
         background-repeat: no-repeat;
         z-index: 99;
         opacity: 1;
         border-radius: 50%;
         border: 3px solid #66d65b;


     }


    }


    }

</style>



// WEBPACK FOOTER //
// src/vue/components/DownloadModalAlert.vue